import React from 'react';
import { PAGE_COMPANY, PAGE_LOATION } from '../../config';

class Footer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<div className="nav-footer">
				<div className="col-lg-2"></div>
				<div
					className="col-lg-8 flex justSb fotterMobileStyle"
					style={{
						height: '150px',
					}}
				>
					<div className='footerBox'>
						<div className='footerLeftBox'>
							<div className='footerLeftBox_top'>
								友情链接
							</div>
							<div className='footerLeftBox_btm'>
								<div className='footerLeftBox_btm_left'>
									<a href='https://zwdt.sh.gov.cn/govPortals/index.do' target='_black' rel='noopener'>上海一网通办</a>
								</div>
								<div className='footerLeftBox_btm_middle'>
									<p>
										<a href='https://www.shgjj.com/' target='_black' rel='noopener'>上海市住房公积金网</a>
									</p>
								</div>
								<div className='footerLeftBox_btm_right'>
									<a href='http://www.shffjt.com/' target='_black' rel='noopener'>奉发集团</a>
								</div>
							</div>
							<div></div>
						</div>
						<div className='footerMiddleBox'>
							<div className='footerMiddleBox_top'>
								联系我们
							</div>
							<div className='footerMiddleBox_btm'>
								<div className='footerMiddleBox_btm_box'>
									<img
										style={{ width: '14px', height: '14px', marginRight: '30px' }}
										src={require('../../assets/images/telephone.png').default}
									></img>
									021-67188885
								</div>
							</div>
							<div></div>
						</div>
						<div className='footerRightBox'>
							<div className='footerRightBox_top'>
								关注我们
							</div>
							<div className='footerRightBox_btm'>
								<div className='footerRightBox_btm_left'>
									<div
										style={{
											width: '150px',
											height: '100%',
										}}
										className="flex flexC justC alignC"
									>
										<div
											style={{
												whiteSpace: 'nowrap',
												margin: '10px 0',
												fontSize: '14px'
											}}
										>
											关注微信公众号
										</div>
										<img
											style={{ width: '90px', height: '90px' }}
											src={
												require('../../assets/images/gzh.png')
													.default
											}
										></img>
									</div>
								</div>
								<div className='footerRightBox_btm_right'>
									<div
										style={{
											width: '150px',
											height: '100%',
										}}
										className="flex flexC justC alignC"
									>
										<div
											style={{
												whiteSpace: 'nowrap',
												margin: '10px 0',
												fontSize: '14px'
											}}
										>
											关注微信小程序
										</div>
										<img
											style={{ width: '90px', height: '90px' }}
											src={
												require('../../assets/images/xcx.png')
													.default
											}
										></img>
									</div>
								</div>
							</div>
							<div></div>
						</div>
						{/* <div className="flex justSa flexC textContent">
							<div>
								Copyright © 2019,{PAGE_COMPANY} 版权所有 All Rights
								Reserved.
							</div>
							<div>
								地址: {PAGE_LOATION}
							</div>
						</div> */}
						{/* <div className="flex justSa">
							<div
								style={{
									width: '150px',
									height: '100%',
								}}
								className="flex flexC justC alignC"
							>
								<img
									style={{ width: '100px', height: '100px' }}
									src={
										require('../../assets/images/xcx.png')
											.default
									}
								></img>
								<div
									style={{
										whiteSpace: 'nowrap',
										marginTop: '20px',
									}}
								>
									奉贤公租房小程序
								</div>
							</div>
							<div
								style={{
									width: '150px',
									height: '100%',
								}}
								className="flex flexC justC alignC"
							>
								<img
									style={{ width: '100px', height: '100px' }}
									src={
										require('../../assets/images/gzh.png')
											.default
									}
								></img>
								<div
									style={{
										whiteSpace: 'nowrap',
										marginTop: '20px',
									}}
								>
									奉贤公租房公众号
								</div>
							</div>
						</div> */}
					</div>
				</div>
				<div className="col-lg-2"></div>
				<div style={{ position: 'absolute', bottom: '5px', width: '100%', textAlign: 'center' }}>沪公网安备31012002002350号备案号:沪ICP备14040323号-1</div>
			</div>
		);
	}
}

export default Footer;
